import BotonAyudaManuales from "../../../Components/BotonAyudaManuales";
import React, { Component } from "react";
import { PageHeader, Row, Empty, Pagination, Spin, message, notification } from "antd";
import { SearchOutlined, SendOutlined } from "@ant-design/icons";
import axios from "axios";
import { connect } from "react-redux";
import { ButtonItem, SelectInsumosItem, InputItem, SegmentedItem, MensajeError } from "../../../Components/Items";
import TarjetaOrdenAlmacen from "./TarjetaOrdenAlmacen";

class Almacen extends Component {
  timeoutBusqueda = null;
  state = {
    loading: false,
    ordenes: [],
    totalRecords: 0,
    page: 1,
    pageSize: 20,
    textoFiltro: "",
    insumoId: undefined,
    seleccionadas: [],
    vista: "pendientes",
  };

  componentDidMount() {
    this.consultarOrdenes();
    window.addEventListener("solicitud_material_produccion", this.onSolicitudMaterial);
  }

  componentWillUnmount() {
    window.removeEventListener("solicitud_material_produccion", this.onSolicitudMaterial);
  }

  onSolicitudMaterial = (event) => {
    const data = event.detail || {};
    notification.info({
      message: `Producción pide material — orden ${data.folio || ""}`,
      description: `${data.cantidadPiezas || ""} pza. de ${data.matrizNombre || ""} en ${data.etapaNombre || ""}${
        data.insumosExtraCount > 0 ? ` + ${data.insumosExtraCount} insumo(s) fuera de lista` : ""
      }${data.solicitanteNombre ? ` (${data.solicitanteNombre})` : ""}`,
    });
    this.setState({ page: 1 }, this.consultarOrdenes);
  };

  consultarOrdenes = () => {
    const { page, pageSize, textoFiltro, insumoId, vista } = this.state;
    this.setState({ loading: true });
    axios
      .post(
        "almacen/dashboardOrdenesPendientesMaterial",
        { empresaId: this.props.empresaId, page, pageSize, textoFiltro, insumoId, vista },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({ ordenes: res.data.data || [], totalRecords: res.data.totalRecords || 0 });
        } else {
          MensajeError({ message: res.data.error || "No se pudo cargar el dashboard de Almacén" });
        }
      })
      .catch(() => this.setState({ loading: false }));
  };

  onChangePagina = (page, pageSize) => this.setState({ page, pageSize }, this.consultarOrdenes);

  onChangeTexto = (e) => {
    const textoFiltro = e.target.value;
    this.setState({ textoFiltro, page: 1 });
    clearTimeout(this.timeoutBusqueda);
    this.timeoutBusqueda = setTimeout(this.consultarOrdenes, 400);
  };

  onChangeInsumoFiltro = (insumoId) => this.setState({ insumoId, page: 1 }, this.consultarOrdenes);

  onChangeVista = (vista) => this.setState({ vista, page: 1 }, this.consultarOrdenes);

  onSeleccionar = (ordenId) => {
    this.setState((prev) => ({
      seleccionadas: prev.seleccionadas.includes(ordenId)
        ? prev.seleccionadas.filter((id) => id !== ordenId)
        : [...prev.seleccionadas, ordenId],
    }));
  };

  verDetalle = (ordenId) => this.props.history.push("/panel/detalleOrdenAlmacen", { ordenId });

  verRequisicion = (requisicionId) => this.props.history.push("/panel/verRequisicion", { id: requisicionId });

  marcarSolicitudAtendida = (ordenId, solicitudId) => {
    axios
      .post(
        "almacen/marcarSolicitudMaterialAtendida",
        { empresaId: this.props.empresaId, usuarioId: this.props.usuarioId, ordenId, solicitudId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Solicitud marcada como atendida");
          this.consultarOrdenes();
        } else {
          MensajeError({ message: res.data.error || "No se pudo marcar la solicitud como atendida" });
        }
      })
      .catch(() => MensajeError({ message: "Error al conectar con el servidor" }));
  };

  requerirSeleccionadas = () => {
    if (this.state.seleccionadas.length < 2) {
      return message.info("Selecciona al menos 2 órdenes para requerir varias a la vez. Para una sola, usa 'Ver detalle'.");
    }
    this.props.history.push("/panel/requerirMaterialOrdenes", { ordenesIds: this.state.seleccionadas });
  };

  render() {
    const { ordenes, loading, totalRecords, page, pageSize, seleccionadas } = this.state;

    return (
      <>
        <PageHeader
          title="Almacén: Material de Órdenes de Producción"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={[
            <SegmentedItem
              key="vista"
              options={[
                { label: "Pendientes", value: "pendientes" },
                { label: "Terminadas", value: "terminadas" },
                { label: "Todas", value: "todas" },
              ]}
              value={this.state.vista}
              onChange={this.onChangeVista}
            />,
            <InputItem
              key="texto"
              prefix={<SearchOutlined />}
              placeholder="Buscar por folio..."
              style={{ width: 220 }}
              value={this.state.textoFiltro}
              onChange={this.onChangeTexto}
            />,
            <SelectInsumosItem
              key="insumoFiltro"
              empresaId={this.props.empresaId}
              headersToken={this.props.headersToken}
              placeholder="Buscar por insumo usado..."
              style={{ width: 280 }}
              allowClear
              value={this.state.insumoId}
              onChange={this.onChangeInsumoFiltro}
            />,
            <ButtonItem
              key="requerirVarias"
              botonAncho
              mostaza
              icon={<SendOutlined />}
              disabled={seleccionadas.length < 2}
              onClick={this.requerirSeleccionadas}
            >
              Requerir seleccionadas ({seleccionadas.length})
            </ButtonItem>,
            <BotonAyudaManuales key="manuales" modulo="almacenProduccionPU" />,
          ]}
        />

        <div style={{ backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)" }}>
          <Spin spinning={loading}>
            {ordenes.length === 0 ? (
              <Empty description="No hay órdenes de producción con material pendiente en tus proyectos" />
            ) : (
              <>
                <Row gutter={[12, 12]}>
                  {ordenes.map((orden) => (
                    <TarjetaOrdenAlmacen
                      key={orden._id}
                      orden={orden}
                      seleccionada={seleccionadas.includes(orden._id)}
                      onSeleccionar={this.onSeleccionar}
                      onVerDetalle={this.verDetalle}
                      onVerRequisicion={this.verRequisicion}
                      onMarcarAtendida={this.marcarSolicitudAtendida}
                    />
                  ))}
                </Row>
                <Row justify="end" style={{ marginTop: 16 }}>
                  <Pagination
                    current={page}
                    pageSize={pageSize}
                    total={totalRecords}
                    showSizeChanger
                    pageSizeOptions={["12", "20", "40", "60"]}
                    onChange={this.onChangePagina}
                    onShowSizeChange={this.onChangePagina}
                  />
                </Row>
              </>
            )}
          </Spin>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  usuarioId: state.user.usuarioId,
});

export default connect(mapStateToProps)(Almacen);
